export default {
  EXPERIMENTS_ENABLED: true,
};
